import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter, WithRouterProps } from 'react-router';

import { withIntl, IntlProps } from 'ha/i18n';
import { GlobalState } from 'ha/types/store';
import { getIsAdmin, getImpersonatingAdmin } from '../selectors';
import { fetchImpersonationInfo, impersonateUser } from '../actions';

interface ImpersonatingAdmin {
  id: number;
  name: string;
}

interface ChildrenFn {
  impersonatingAdmin: ImpersonatingAdmin | null;
  onStop: () => void;
}

interface Props {
  isAdmin: boolean;
  impersonatingAdmin: ImpersonatingAdmin | null;
  children: (args: ChildrenFn) => React.ReactNode;
  onMount: () => void;
  onImpersonate: (id: number, nextUrl: string) => void;
}

export class ImpersonationContainer extends React.Component<
  Props & IntlProps & WithRouterProps
> {
  componentDidMount() {
    const { isAdmin, location, onMount, onImpersonate } = this.props;
    const { id2 } = location.query;

    if (isAdmin && id2) {
      onImpersonate(parseInt(id2, 10), location.pathname);
    } else {
      onMount();
    }
  }

  handleStop = () => {
    const {
      onImpersonate,
      intl: { urlResolver },
    } = this.props;

    onImpersonate(0, urlResolver.getAdminPagesUrl());
  };

  render() {
    const { children, impersonatingAdmin } = this.props;

    return children({
      impersonatingAdmin,
      onStop: this.handleStop,
    });
  }
}

export default connect(
  (state: GlobalState) => ({
    isAdmin: getIsAdmin(state),
    impersonatingAdmin: getImpersonatingAdmin(state),
  }),
  {
    onMount: fetchImpersonationInfo,
    onImpersonate: impersonateUser,
  },
)(withIntl(withRouter(ImpersonationContainer)));
